module.exports = __webpack_public_path__ + "img/img21.4e9e19ab.svg";